import { useMemo } from 'react';

import { simplifyBuilder } from '@cd3p/core';
import {
  CoreSensitiveData,
  coreSensitiveDataMethods,
  coreSensitiveDataState,
} from '@cd3p/core/modules/sensitiveData';

import { bindActionCreators, useDispatch, useSelector } from 'third-party';

import { appSelectors } from 'selectors';

export type SensitiveDataState = CoreSensitiveData;

export const sensitiveDataState: SensitiveDataState = {
  ...coreSensitiveDataState,
};

export const sensitiveDataBuilder = simplifyBuilder(sensitiveDataState, {});

const requestSensitiveData = sensitiveDataBuilder.createServerAction(
  coreSensitiveDataMethods.requestSensitiveData,
);

const reviewSensitiveData = sensitiveDataBuilder.createServerAction(
  coreSensitiveDataMethods.reviewSensitiveData,
);

export const useSensitiveData = () => {
  const dispatch = useDispatch();
  const providerId = useSelector(appSelectors.providerId);

  return useMemo(
    () =>
      bindActionCreators(
        {
          requestSensitiveData: requestSensitiveData.bind(null, providerId),
          reviewSensitiveData: reviewSensitiveData.bind(null, providerId),
        },
        dispatch,
      ),
    [dispatch, providerId],
  );
};

export const sensitiveDataReducer = sensitiveDataBuilder.getReducers();
